import React from 'react'
import { AddToWatchlistIcon, RemoveFromWatchlistIcon } from '~/assets/svg'

const watchlistBtn = props => {
  return (
    <div className="queue-button">
    { props.isAdded
      ? <div className="remove" onClick={ props.remove }>
          <RemoveFromWatchlistIcon />
        </div>
      : <div className="add" onClick={ props.add }>
          <AddToWatchlistIcon />
        </div>
    }
    </div>
  )
} 

export default watchlistBtn